import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Role} from '../../../graphql/auth';
import {gqlRole} from '../getRole.api';

interface UpdateRoleVars {
    data: {
        id: number
        name?: string
        ident?: string
        description?: string
        active?: boolean
        level?: number
        permissions?: {
            connect?: number[]
            disconnect?: number[]
        }
    }
}

interface UpdateRoleData {
    __typename?: string,
    updateRole: Role
}

export const UPDATE_ROLE_MUTATION = gql`
    mutation updateRole($data: UpdateRoleInput!) {
        updateRole(data: $data) {
            ${gqlRole}
        }
    }
`;

export const updateRole = () => useMutation<UpdateRoleData, UpdateRoleVars>(
    UPDATE_ROLE_MUTATION,
    {}
);

export default updateRole;